import React, { useContext } from 'react';
import { LiveTrainStatusContext } from '../LiveTrainStatus';

export function TrainNameNumber(props) {
  const { ltsPageState } = useContext(LiveTrainStatusContext);
  const { trainName, trainNumber } = { ...ltsPageState };
  return (
    <div className="ltsSeoPage__train makeFlex hrtlCenter appendBottom25">
      <span className="appendRight10 railSeoSprite trainIcon--purple" />
      <p className="makeFlex column">
        <span className="font20 latoHeavy blackText">{`#${trainNumber}`}</span>
        <span className="font14 lineHeight22">{trainName}</span>
      </p>
    </div>
  );
}
export default TrainNameNumber;
